import type { ReactNode } from "react";
import { cn } from "@/lib/utils/cn";
import type { Tone } from "./labels";

const TONE_CLASS: Record<Tone, string> = {
  neutral: "nx-badge-neutral",
  info: "nx-badge-info",
  success: "nx-badge-success",
  warning: "nx-badge-warning",
  danger: "nx-badge-danger",
  accent: "nx-badge-accent",
};

export function Badge({
  tone = "neutral",
  children,
  className,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return <span className={cn(TONE_CLASS[tone], className)}>{children}</span>;
}

/** Círculo con iniciales del nombre. Color único (accent) para no depender
 *  de tokens por persona. */
export function Avatar({ name, size = 22 }: { name?: string | null; size?: number }) {
  const initials =
    (name || "?")
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((w) => w[0]?.toUpperCase() ?? "")
      .join("") || "?";
  return (
    <span
      title={name || undefined}
      className="inline-flex items-center justify-center rounded-full bg-accent-soft text-accent font-medium shrink-0"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}
    >
      {initials}
    </span>
  );
}

/** Etiqueta de campo + valor, para los drawers de edición. */
export function FieldLabel({ children }: { children: ReactNode }) {
  return <label className="nx-eyebrow block mb-1">{children}</label>;
}
